export default async function setTargetOnBasket({ graphql, state, props }) {
  const { ids } = props
  if (ids.length > 0) {
    const result = await graphql.mutate(`{
          setTarget(orderId: "${state.get(
            'basket.orderId'
          )}",orderItemIds: [${ids.join()}], targetId: "${props.target}") {
            id
            orderItems {
              id
              target {
                name
                width
                dpi
                hasLimit
              }
              source {
                id
                name
                thumbnail
                metaData {
                  ratio {
                    width
                    height
                  }
                }
              }
            }
          }
        }`)

    let orderItem = null
    if (ids.length === 1) {
      orderItem = result.setTarget.orderItems.reduce((acc, orderItem) => {
        if (`"${orderItem.id}"` === ids[0]) {
          acc = orderItem
        }
        return acc
      }, {})
    }

    return { order: result.setTarget, orderItem }
  }
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/setTargetOnOrderItems.js